import React from 'react';
import styled from 'styled-components';
import MotifOption from '@ey/motif-react-wrapper/Option';

export default function Option(props) {
	const {id, className, title, value, onClick, disabled} = props;
	return (
		<StyledMotifOption id={id} className={className} title={title} value={value} onClick={onClick} disabled={disabled}>
			{value}
		</StyledMotifOption>
	);
}

const StyledMotifOption = styled(MotifOption)``;
